import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import propTypes from "@styled-system/prop-types";
import ButtonStyle from "./button.style";
import LoadingSpinner from "../loadingSpinner";

const Button = ({
  children,
  type,
  block,
  iconPosition,
  active,
  loading,
  disabled,
  onClick,
  innerRef,
  className,
  ...attributes
}) => {
  const buttonIcon = loading ? <LoadingSpinner width={14} pt="2px" ml={3} /> : null;
  const position = iconPosition || "right";
  const classes = classNames(
    className,
    block ? "btn-block" : false,
    active ? "active" : false,
    disabled || loading ? "disabled" : false,
  );

  const click = e => !disabled && onClick && onClick(e);

  return (
    <ButtonStyle
      type={type}
      className={classes}
      {...attributes}
      disabled={disabled || loading}
      onClick={click}
      ref={innerRef}
    >
      {position === "left" && buttonIcon}
      {children}
      {position === "right" && buttonIcon}
    </ButtonStyle>
  );
};

const layoutProps = { ...propTypes.layout };
delete layoutProps.size;

Button.propTypes = {
  type: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  variant: PropTypes.oneOf(["", "pill", "square"]),
  colors: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "danger",
    "primaryWithBg",
    "secondaryWithBg",
    "infoWithBg",
    "successWithBg",
    "warningWithBg",
    "dangerWithBg",
  ]),
  block: PropTypes.bool,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  active: PropTypes.bool,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  ...layoutProps,
  ...propTypes.space,
};

Button.defaultProps = {
  type: "button",
  variant: "",
  block: false,
  active: false,
  loading: false,
  disabled: false,
};

export default Button;
